<template>
  <v-card color="#F2F2F2" class="pa-2" elevation="0">
    <template v-if="loading">
      <v-skeleton-loader class="mx-auto" type="card-heading" />
    </template>
    <v-card-text v-else>
      <template v-if="$slots.default">
        <slot />
      </template>
      <template v-else>
        <div class="d-flex align-center">
          <svg-icon
            v-if="iconDriver == 'local'"
            :size="iconSize"
            :name="icon"
          />
          <v-icon v-else-if="iconDriver == 'library'" :size="iconSize">{{
            icon
          }}</v-icon>
          <span
            class="text-black text-secondary font-weight-bold text-right ml-auto"
          >
            {{ title }} <br />
            <h6 class="font-weight-bold" :class="valueClass">
              {{ formattedValue }}
            </h6>
          </span>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import SvgIcon from '@/components/icons/SvgIcon.vue';
  import numbersFormats from '@/mixins/numbersFormats';
  export default {
    name: 'KPICard',
    components: { SvgIcon },
    mixins: [numbersFormats],
    props: {
      title: {
        type: String,
        required: true,
      },
      value: {
        type: [Number, String],
        required: true,
      },
      icon: {
        type: String,
        required: true,
      },
      iconSize: {
        type: [Number, String],
        default: 55,
      },
      valueClass: {
        type: String,
        default: '',
      },
      format: {
        type: String,
        required: true,
        validator: (value) =>
          ['number', 'currency', 'percentage'].includes(value),
      },
      iconDriver: {
        type: String,
        required: true,
        validator: (value) => ['local', 'library'].includes(value),
      },
      loading: Boolean,
    },

    computed: {
      formattedValue() {
        const number = Number(this.value);
        switch (this.format) {
          case 'number':
            return this.formatNumber(number, '');
          case 'percentage':
            return this.fomatPercent(number);
          case 'currency':
            return this.formatNumber(number, '$', 0);
          default:
            return 0;
        }
      },
    },
  };
</script>
